import buildUrl from 'modules/core/lib/buildUrl'
import { Model } from 'modules/core/lib/mobx-rest'

export interface IFile {
  [key: string]: any
}

class File extends Model<IFile> {
  INCIDENCE_MESSAGE_FILE_TYPE = 'incidence_message'

  static urlRoot() {
    return '/bookkeepers_management/files'
  }

  downloadUrl(bookkeeperView = false): string {
    return this.attributes.type !== this.INCIDENCE_MESSAGE_FILE_TYPE
      ? buildUrl(
          `/documents/${this.id}?download=true&inline=true&bookkeeper_view=${bookkeeperView}`
        )
      : buildUrl(
          `/bookkeepers_management/incidence_messages/${this.attributes.incidence_message_id}/file/${this.id}?bookkeeper_view=${bookkeeperView}`
        )
  }
}

export default File
